export const encryptId = (value: any) => {
  const randomString =
    Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)

  const encoder = new TextEncoder()
  const bytes = encoder.encode(value.toString())

  const binary = Array.from(bytes)
    .map((b) => String.fromCharCode(b))
    .join('')

  const encodedValue = btoa(binary)

  return btoa(randomString + '-' + encodedValue)
}

export const decryptId = (id?: string | null) => {
  if (!id) return ''

  try {
    const decoded = atob(id)
    const encoded = decoded.split('-')[1]

    const binary = atob(encoded)
    const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0))

    const decoder = new TextDecoder()
    return decoder.decode(bytes)
  } catch {
    return ''
  }
}
